export default "__VITE_ASSET__Ps$Qzcoi__"